"use client";

import { Skeleton } from "@/app/ui/imported/skeleton";
import { useSearchParams } from "next/navigation";
import { Suspense } from "react";

export default function CurrentUrl() {
    return (
        <p className="text-sm">כתובת האתר שניסית להציג: <span className="text-red-100">
            <Suspense fallback={ <Skeleton className="h-1em w-20" /> } >
                <Url />
            </Suspense>
        </span></p>
    )
}

function Url() {
    const searchParams = useSearchParams()
    const callbackUrl = searchParams.get("callbackUrl");
    return <>{ callbackUrl }</>
}